var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCookie } from '../utilities/cookies.util';
import settings from "../settings";
import { getAdobeData } from './mid.service';
var customVariables = {};
var PREVIOUS_SCREEN = '';
var CURRENT_SCREEN = '';
export var getClientVariables = function () { return (__assign({ cacheBuster: (new Date()).getTime() + "." + Math.floor(Math.random() * 1000000), visitor: getVisitorDetails(), screen: {
        url: window.location.href,
        screenId: CURRENT_SCREEN,
        pageTitle: document.title,
        referrer: getReferrer(),
    }, device: {
        colorDepth: screen.colorDepth,
        javaScriptVer: settings.javaScriptVer,
        screenRes: "".concat(window.screen.width, "x").concat(window.screen.height),
        browserRes: "".concat(window.innerWidth, "x").concat(window.innerHeight)
    }, location: getLocationDetails() }, customVariables)); };
/**
 * Analytics Api: addCustomVariables.
 * Appends custom variables to the client variables
 *
 * @param {object} variables Object containing custom variables to be added
 *
 * @example
 * import { addCustomVariables } from "@octagon/public-analytics";
 *
 * addCustomVariables({key: "value"});
 * @category Services
 */
export function addCustomVariables(variables) {
    customVariables = __assign(__assign({}, customVariables), variables);
}
/**
 * Analytics Api: resetCustomVariables.
 * Removes any custom variables added to client variables.
 * @example
 * import { resetCustomVariables } from "@octagon/public-analytics";
 *
 * resetCustomVariables();
 * @category Services
 */
export function resetCustomVariables() {
    customVariables = {};
}
export function setCurrentScreen(screenId) {
    PREVIOUS_SCREEN = CURRENT_SCREEN;
    CURRENT_SCREEN = screenId;
}
export var getReferrer = function () {
    var referrerUrl = document.referrer ? document.referrer : PREVIOUS_SCREEN ? window.location.href : '';
    var hasParams = referrerUrl.indexOf('?') !== -1;
    var pageName = "".concat(hasParams ? '&' : '?', "pg_name=").concat(PREVIOUS_SCREEN);
    return "".concat(referrerUrl).concat(PREVIOUS_SCREEN ? pageName : '');
};
export var getVisitorDetails = function () {
    var adobeData = getAdobeData(), visitorId = getCookie(settings.visitorIdKey), smSessionCookie = getCookie(settings.smSessionKey);
    return {
        mid: adobeData ? adobeData.mid : undefined,
        adobeData: adobeData ? adobeData.adobeCookie : undefined,
        visitorType: "unkwn",
        visitorId: visitorId ? visitorId : undefined,
        loggedInState: (smSessionCookie === 'LOGGEDOFF' || !smSessionCookie) ? 'N' : (smSessionCookie.length > 0 ? 'Y' : 'N')
    };
};
export var getLocationDetails = function () {
    var offsetMin = new Date().getTimezoneOffset();
    var offsetHours = offsetMin / 60;
    var absOffsetHours = Math.abs(offsetHours);
    var finalOffsetHours;
    // TODO: refactor this if else block
    if (offsetHours === 0) {
        finalOffsetHours = '+0';
    }
    else {
        if (absOffsetHours < 10) { // requires padding
            if (offsetHours < 0) { // negative - flip to positive
                finalOffsetHours = (''.concat('+', String(absOffsetHours)));
            }
            else { // positive - flip to negative
                finalOffsetHours = (''.concat('-', String(absOffsetHours)));
            }
        }
        else { // no padding required
            if (offsetHours < 0) { // negative - flip to positive
                finalOffsetHours = ('+'.concat(String(absOffsetHours)));
            }
            else { // positive - flip to negative
                finalOffsetHours = ('-'.concat(String(absOffsetHours)));
            }
        }
    }
    return {
        timezone: new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2],
        tz_offset: finalOffsetHours
    };
};
